export const ROADMAP_TOY_FIELDS = `
  id
  toyNumber
  type
  name
  images {
    url
    order
  }
  ageGroups {
    id
    minAge
    maxAge
  }
`;

export const ROADMAP_FIELDS = `
  userSubscriptionId
  startedAt
  isStarted
  currentWeekNumber
  weeks {
    weekNumber
    isCurrentWeek
    expectedDeliveryDate
    slots {
      id
      weekNumber
      slotPosition
      slotKey
      toyId
      isOrderPlaced
      orderId
      orderNumber
      orderStatus
      isReturned
      returnOrderId
      returnOrderNumber
      returnOrderStatus
      toy {
        ${ROADMAP_TOY_FIELDS}
      }
    }
  }
`;

export const CHILD_PROFILE_FIELDS = `
  id
  firstName
  lastName
  profileImage
  gender
  dateOfBirth
  isActive
  isDefault
  isDobUpdatable
  createdAt
  updatedAt
`;

export const TOY_SCHEDULE_ORDER_RESULT_FIELDS = `
  toyNumber
  status
  orderNumber
  weekNumber
  weekStartDate
  expectedDeliveryDate
  error
`;
